export const buildingDetail = {
  title: "Hoone detailid",
  description: "Vaata ja halda hoone informatsiooni",
  basicInfo: "Põhiinfo",
  additionalDetails: "Lisaandmed",
  brief: {
    title: "Projekti ülevaade",
    description: "Projekti ülevaade ja nõuded",
    basics: "Põhiinfo",
    technical: "Tehniline",
    systems: "Süsteemid",
    requirements: "Nõuded",
    export: "Ekspordi ülevaade",
    exportSuccessTitle: "Ülevaade eksporditud",
    exportSuccessDesc: "Projekti ülevaade on edukalt eksporditud",
    exportErrorDesc: "Projekti ülevaate eksportimine ebaõnnestus",
    updateSuccessTitle: "Ülevaade uuendatud",
    updateSuccessDesc: "Projekti ülevaade on edukalt uuendatud",
    updateErrorDesc: "Projekti ülevaate uuendamine ebaõnnestus",
    loadError: "Projekti ülevaate laadimine ebaõnnestus",
  },
  insights: {
    title: "Hoone tähelepanekud",
    description: "AI-genereeritud tähelepanekud ja soovitused",
    analyze: "Analüüsi hoonet",
    showActive: "Näita aktiivseid",
    showResolved: "Näita lahendatud",
    noInsights: "Tähelepanekud puuduvad",
    noActiveInsights:
      "Aktiivsed tähelepanekud puuduvad. Klõpsa 'Analüüsi hoonet', et skannida võimalikke probleeme.",
    noResolvedInsights: "Lahendatud tähelepanekud puuduvad.",
    failedToLoad: "Tähelepanekute laadimine ebaõnnestus. Palun proovi uuesti.",
    loadError: "Viga",
    recommendations: "Soovitused:",
    resolve: "Lahenda",
    resolvedOn: "Lahendatud:",
    energyPerformance: {
      title: "Energiatõhususe analüüs",
      description: "Hoone energiatõhususe hindamine olemasolevate andmete põhjal",
      highConsumption: "Tuvastatud kõrge energiatarbimine",
      lowEfficiency: "Madal energiatõhususe hinnang",
      goodPerformance: "Hea energiatõhusus",
      noData: "Ebapiisavad energiaandmed",
      ratings: {
        description:
          "Hoone energiatõhususe klass on {rating}, mis näitab {performance} energiatõhusust.",
        a: "suurepärast",
        b: "väga head",
        c: "head",
        d: "keskmist",
        e: "keskmisest madalamat",
        f: "halba",
        g: "väga halba",
      },
      recommendations: {
        audit: "Teosta põhjalik energiaaudit",
        upgrade: "Uuenda energiatõhusate süsteemide ja seadmetega",
        renewable: "Kaalu taastuvenergia allikate rakendamist",
        monitoring: "Paigalda energiatarbimise jälgimissüsteemid",
        insulation: "Paranda hoone soojustust soojuskao vähendamiseks",
        windows: "Uuenda aknad energiatõhusate mudelitega",
        envelope: "Kaalu hoone välispiirde renoveerimist",
        smartSystem: "Rakenda nutikas hoonehaldussüsteem",
        heatPump: "Kaalu soojuspumba süsteemile üleminekut",
        biomass: "Hinda taastuvaid küttelahendusi nagu biomass või päikesekollektorid",
        solarThermal: "Paigalda päikesekollektorid vee soojendamiseks",
        hybridSystem: "Rakenda hübriidne küttesüsteem fossiilkütuste tarbimise vähendamiseks",
        energyAssessment: "Teosta energiatõhususe hindamine",
        retrofitStrategy: "Tööta välja põhjalik energiarenoveerimise strateegia",
        deepRetrofit: "Kaalu põhjalikku energiarenoveerimist maksimaalse säästu saavutamiseks",
        subsidies: "Taotle rohehoonete renoveerimise toetusi või subsiidiume",
        maintenanceCheck: "Planeeri kõigi KVVK süsteemide hoolduskontroll",
        replaceOldSystems: "Kaalu üle 15 aasta vanuste süsteemide väljavahetamist",
        highEfficiencyEquipment: "Uuenda kõrge efektiivsusega KVVK seadmetega",
        smartControls: "Rakenda nutikad juhtimissüsteemid optimaalseks toimimiseks",
      },
    },
    fireSafety: {
      title: "Tuleohutuse analüüs",
      description: "Hoone tuleohutussüsteemide ja -komponentide hindamine",
      improvementsNeeded: "Tuvastatud puudused tuleohutuses",
      enhancementsRecommended: "Tuleohutuse täiendamist soovitatav",
      missingComponents: "Hoones puuduvad olulised tuleohutuskomponendid: {components}",
      additionalMeasures: "Soovitatud täiendavad tuleohutuse meetmed hoone ohutuse parandamiseks",
      recommendations: {
        fireAlarm: "Paigaldada heakskiidetud tulekahjusignalisatsiooni süsteem",
        emergencyLighting: "Tagada korralik hädaolukorra valgustus",
        evacuationRoutes: "Märgistada selgelt evakuatsiooniteed",
        smokeDetectors: "Paigaldada suitsuandurid kriitilistesse piirkondadesse",
        sprinklerSystem: "Kaaluda sprinklersüsteemi rakendamist",
        fireExtinguishers: "Asetada tulekustutid igal korrusel ligipääsetavatesse kohtadesse",
        emergencyExits: "Tagada hädaväljapääsude selge märgistus",
        fireDrills: "Teostada regulaarseid tuleohutuse õppusi",
        safetyPlan: "Luua hoone tuleohutusstrateegia",
      },
    },
    priority: {
      low: "Madal",
      medium: "Keskmine",
      high: "Kõrge",
      critical: "Kriitiline",
    },
  },
  actions: {
    title: "Hoone tegevused",
    viewESG: "ESG aruanne",
    viewBrief: "Projekti \u00FClevaade",
    viewLCA: "Eluts\u00FCkli anal\u00FC\u00FCs",
    viewBudget: "Eelarve",
    viewPermits: "Ehitusloa andmed",
    viewPayments: "Maksed",
    viewBudgetProjections: "Prognoosid",
  },
  overview: {
    dataQuality: "Andmete kvaliteet",
    dataCompletenessDesc: "Hoone andmete t\u00E4ielikkus",
    documents: "Dokumendid",
    documentsDesc: "\u00DCleslaaditud dokumentide arv",
    lastUpdated: "Viimati uuendatud",
    lastUpdatedDesc: "Viimane andmete uuendus",
    title: "Hoone \u00FClevaade",
  },
  dashboard: {
    registryCode: "Registrikood",
    netArea: "Netopind",
    floors: "Korruseid",
    floorsUnderground: "maa-alune",
    heatingSource: "K\u00FCtteallikas",
    editBuilding: "Muuda",
    fieldsSaved: "Hoone andmed uuendatud",
    fieldsSaveError: "Hoone andmete uuendamine ebaõnnestus",
    uploadDocuments: "Laadi dokumendid \u00FCles",
    projects: "Projektid",
    documents: "Dokumentide anal\u00FC\u00FCtika",
    analyticsPartialAccess:
      "Anal\u00FC\u00FCtikat ei kuvata, sest teil puudub juurdep\u00E4\u00E4s k\u00F5igile selle projekti dokumentidele.",
    total: "Faile kokku",
    processed: "T\u00F6\u00F6deldud",
    filesAllProcessed: "{count} faili \u00B7 k\u00F5ik t\u00F6\u00F6deldud",
    fileAllProcessedOne: "1 fail \u00B7 t\u00F6\u00F6deldud",
    unsupportedTypesTooltip:
      "M\u00F5nda \u00FCleslaaditud failit\u00FC\u00FCpi Franklin hetkel veel nutikalt ei t\u00F6\u00F6tle, seega ei kajastu need siinses arvestuses.",
    documentsByGroup: "Dokumendid:",
    expandChart: "Suurenda graafikut",
    legendShowMore: "+{count} veel",
    groupCategory: "Kategooria",
    groupDiscipline: "Valdkonnad",
    groupStage: "Staadiumid",
    uploadActivity: "\u00DCleslaadimise aktiivsus",
    documentsPerProject: "Dokumendid projekti kohta",
    range30d: "30p",
    range90d: "90p",
    range1y: "1a",
    tooltipTotal: "Kokku",
    noDocuments: "Dokumendid puuduvad",
    noData: "Andmed puuduvad",
    noUploads30d: "Viimase 30 päeva jooksul pole üleslaadimisi",
    noUploads90d: "Viimase 90 päeva jooksul pole üleslaadimisi",
    noUploads1y: "Viimase aasta jooksul pole üleslaadimisi",
    noUploadsHint: "Proovi pikemat ajavahemikku",
    other: "Muu",
  },
};
